import axios from "axios";
import { CLOUDFRONT_BASE_URL } from "./config";



export interface CookieResponse {
  ok: boolean;
  scope: string;
  domain: string;
  expiresAt: number;
  expiresAtIso: string;
}

// Axios instance that talks to CloudFront; cookies must be included.
const api = axios.create({
  baseURL: CLOUDFRONT_BASE_URL,
  withCredentials: true, // critical for cross-site Set-Cookie
});

// Call the Lambda via CloudFront to set cookies on the CF domain.
export const getCookies = async (path = "/outputs/hls/*", hours = 24): Promise<CookieResponse> => {
  const res = await api.post<CookieResponse>("/auth/cookies", {
    path,
    expiresInHours: hours,
  }, {
    headers: { "Content-Type": "application/json" },
  });

  return res.data;
};

export { CLOUDFRONT_BASE_URL };